import React, { useEffect } from "react";
import { X, Package } from "lucide-react";

export const InventoryPanel = ({ open, onClose, items }) => {
  useEffect(() => {
    if (!open) return;
    const h = (e) => { if (e.key === "Escape") onClose(); };
    window.addEventListener("keydown", h);
    return () => window.removeEventListener("keydown", h);
  }, [open, onClose]);
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center" data-testid="inventory-modal">
      <div className="absolute inset-0 bg-black/85 backdrop-blur-sm" onClick={onClose} />
      <div className="relative w-full max-w-3xl bg-deepshadow border border-white/10 p-10 mx-4 animate-fadein">
        <div className="flex items-center justify-between mb-8">
          <div className="flex items-center gap-3">
            <Package size={16} className="text-white/60" />
            <h3 className="font-mono text-xs tracking-[0.35em] uppercase text-white/60">INVENTORY // {items.length} ITEMS</h3>
          </div>
          <button onClick={onClose} className="text-white/50 hover:text-emergency transition-colors" data-testid="inventory-close">
            <X size={18} />
          </button>
        </div>
        {items.length === 0 ? (
          <p className="narrative text-white/40 text-center py-12">Your pockets are empty. Your hands shake anyway.</p>
        ) : (
          <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
            {items.map((it, i) => (
              <div key={`${it}-${i}`} className="border border-white/10 bg-black/40 p-4 hover:border-emergency/60 transition-colors" data-testid={`inv-item-${i}`}>
                <div className="font-mono text-[10px] text-white/40 mb-1">// ITEM {String(i + 1).padStart(2, "0")}</div>
                <div className="narrative text-sm text-white/85 crt-text">{it}</div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};
